import React from 'react';
import { Box, CircularProgress, CssBaseline } from '@mui/material';

export default function Loader({ fullHeight }) {
  return (
    <Box
      display="flex"
      height={fullHeight ? '100vh' : 'calc(100vh - 100px)'}
      justifyContent="center"
      alignItems="center"
    >
      <CssBaseline />
      <CircularProgress />
    </Box>
  );
}
